<ul *ngIf="passwordElement?.errors?.pattern" class="alert alert-danger p-5">
  <li>Password should have at minimum 6 characters.</li>
  <li>Password should have at least 1 number.</li>
  <li>Password should have at least 1 letter.</li>
  <li>Password should have at least 1 lower- and upper-case character.</li>
  <li>Password should have at 1 special character.</li>
</ul>
